import fetch from 'lib/fetch'

export const REQUEST_INTEGRATIONS_BY_WORKSPACE_SLUG = 'REQUEST_INTEGRATIONS_BY_WORKSPACE_SLUG'
export const REQUEST_INTEGRATIONS_BY_WORKSPACE_SLUG_ERROR = 'REQUEST_INTEGRATIONS_BY_WORKSPACE_SLUG_ERROR'
export const RECEIVE_INTEGRATIONS_BY_WORKSPACE_SLUG = 'RECEIVE_INTEGRATIONS_BY_WORKSPACE_SLUG'

export function fetchIntegrationsByWorkspaceSlug (workspaceSlug) {
  return {
    types: {
      request: REQUEST_INTEGRATIONS_BY_WORKSPACE_SLUG,
      failure: REQUEST_INTEGRATIONS_BY_WORKSPACE_SLUG_ERROR,
      receive: RECEIVE_INTEGRATIONS_BY_WORKSPACE_SLUG
    },
    callAPI: () => fetch(`/api/workspaces/${workspaceSlug}/integrations`).then(res => {
      if (!res.ok) {
        const err = new Error('Unable to fetch integrations')
        err.status = res.status
        throw err
      }
      return res.json()
    }),
    payload: { workspaceSlug }
  }
}

export const UPDATE_INTEGRATION = 'UPDATE_INTEGRATION'
export const UPDATE_INTEGRATION_ERROR = 'UPDATE_INTEGRATION_ERROR'
export const UPDATED_INTEGRATION = 'UPDATED_INTEGRATION'

export function updateIntegration (workspaceSlug, sourceSlug, integrationName, settings) {
  return {
    types: {
      request: UPDATE_INTEGRATION,
      failure: UPDATE_INTEGRATION_ERROR,
      receive: UPDATED_INTEGRATION
    },
    callAPI: () => fetch(`/api/workspaces/${workspaceSlug}/projects/${sourceSlug}/integrations/${integrationName}`, {
      method: 'PUT',
      body: JSON.stringify(settings)
    }).then(res => {
      if (!res.ok) {
        const err = new Error('Unable to save integration settings')
        err.status = res.status
        throw err
      }
      return res.json()
    }),
    payload: { workspaceSlug }
  }
}



// WEBPACK FOOTER //
// ./actions/integrations.js